import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseAlerts } from '../data/content';
const SHOW_MS = 6000;
const HIDE_MS = 11000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const cycle = (show: boolean) => {
      setVisible(show);
      timeout = window.setTimeout(() => {
        if (!show) setIndex(prev => (prev + 1) % purchaseAlerts.length);
        cycle(!show);
      }, show ? SHOW_MS : HIDE_MS);
    };
    timeout = window.setTimeout(() => cycle(true), 8000);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const alert = purchaseAlerts[index];
  return <AnimatePresence data-id="element-225" data-mp="1gydz6bls19oq">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[104px] left-3 right-3 z-30 sm:left-4 sm:right-auto sm:max-w-xs" role="status" aria-live="polite" data-id="element-226" data-mp="165hc2uszy76i">
          <div className="flex items-start gap-3 rounded-xl border border-white/10 bg-navy-800 p-3 pr-8 shadow-2xl" data-id="element-227" data-mp="n6brvvw3flmz">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-500/15" data-id="element-228" data-mp="i9bra0i0jb39">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-400" aria-hidden="true" data-id="element-229" data-mp="x6m0f376o4vt" />
            </span>
            <div className="min-w-0" data-id="element-230" data-mp="s8aq6rcz7sd2">
              <p className="text-sm font-700 leading-snug text-white" data-id="element-231" data-mp="28jy85p62d7n9">{alert.name}</p>
              <p className="text-xs leading-snug text-slate-300" data-id="element-232" data-mp="23lmzhhri936m">
                just purchased DVO Master Protocol™
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-gold-400" data-id="element-233" data-mp="2anrv54sad8hf">
                {alert.location} · a few minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded p-1 text-slate-400 transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-400/60" data-id="element-234" data-mp="2kn0opwj8ol39">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-235" data-mp="1wv25mqdjtlfk" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}